<template>
<div class="chapter">
<div class="inner_page">
<a id="pvii"></a>
<blockquote class="indent3">
<p class="left sink">Is the Pacifique Sea my home?</p>
<div class="timebreak "> </div>
<p class="right ">—J<span class="smallcaps">OHN</span> D<span class="smallcaps">ONNE,</span><br/>
“Hymne to God my God”</p>
<div class="timebreak "> </div>
<p class="hang ">Stolto! a cui parlo? Misero! Che tento?</p>
<p class="hang ">Racconto il dolor mio</p>
<p class="hang ">a l’insensata riva</p>
<p class="hang ">a la mutola selce, al sordo vento . . .</p>
<p class="hang ">Ahi, ch’altro non risponde</p>
<p class="hang ">che il mormorar del’onde!</p>
<div class="timebreak "> </div>
<p class="right ">—G<span class="smallcaps">IOVAN</span> B<span class="smallcaps">ATTISTA</span> M<span class="smallcaps">ARINO,</span><br/>
“Eco,” <em>La Lira,</em> xix</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?4129dfbe